
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon-chord",classNames,staticClass],
              style: [{"isolation":"isolate"},style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","style":"isolation:isolate","viewBox":"0 0 24 24","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"secondary",attrs:{"d":"M7.149 15.316c-.283-1.2 1.233-2.585 3.382-3.09 2.149-.506 4.123.058 4.405 1.258.282 1.2-1.233 2.584-3.382 3.09-2.149.505-4.123-.058-4.405-1.258z"}}),_c('path',{staticClass:"primary",attrs:{"d":"M14.97 4.915v14.566a1 1 0 11-1.994-.014l.29-17.671a1 1 0 011.414 0l4.243 4.243a1 1 0 01-1.415 1.414L14.97 4.915z"}}),_c('path',{staticClass:"primary",attrs:{"d":"M7.149 21.316c-.283-1.2 1.233-2.585 3.382-3.09 2.149-.506 4.123.058 4.405 1.258.282 1.2-1.233 2.584-3.382 3.09-2.149.505-4.123-.058-4.405-1.258z"}})])
          )
        }
      }
    